import { sha3 } from 'hash-wasm';
const PREFIX = 'iBo';
const SUFFIX = 'PrO';

const addSymbol = (token) => {
  if (token.length >= 6) {
    return (
      token.substring(0, 3) +
      PREFIX +
      token.substring(3, token.length - 3) +
      SUFFIX +
      token.substring(token.length - 3, token.length)
    );
  } else if (token.length >= 3) {
    return token.substring(0, 3) + PREFIX + token.substring(3);
  } else {
    return token + SUFFIX;
  }
};

const base64Encode = (str) => btoa(str);

export const encryptToken = (token) => {
  return addSymbol(base64Encode(addSymbol(token)));
};

export const generateXHash = async (str) => {
  const time = new Date().getTime().toString();
  const encStr = encryptToken(str + time);
  const hash = await sha3(encStr.normalize());
  return encryptToken(hash + time);
};
